import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles<Theme>((theme) =>
  createStyles({
    container: {
      padding: '0',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
    },
    wrapper: {
      height: '100%',
    },
    link: {
      display: 'inline-flex',
      color: theme.palette.primary.contrastText,
      fontWeight: theme.typography.fontWeightBold,
      fontSize: 16,
      alignItems: 'center',
      '& svg': {
        marginRight: theme.spacing(1),
      },
    },
    title: {
      color: theme.palette.primary.light,
      fontWeight: theme.typography.fontWeightBold,
      fontSize: 20,
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1),
    },
    card: {
      minHeight: 'auto',
    },
  })
);

export default useStyles;
